import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { EditButton } from "components/Buttons";
import { MissionRolesPicker } from "components/Missions/Roles";

/**
 * ApplicantListMissionRoleFilter
 * @param {Object} selected
 * @param {Function} setSelected
 * @param {Boolean} showOnlyPublishedRoles
 */
const ApplicantListMissionRoleFilter = ({ selected, setSelected, showOnlyPublishedRoles }) => {
  const [showForm, setShowForm] = useState(false);
  const [missionRoleIds, setMissionRoleIds] = useState(selected?.missionRoleIds);

  return (
    <>
      <EditButton disabled={!selected?.organizationId} onClick={() => setShowForm(true)}>
        {selected?.missionRoleIds?.length > 0 ? (
          <FormattedMessage
            id="Missions.Applicants.MissionRoleFilter.EditButtonText.Roles"
            values={{ count: selected?.missionRoleIds?.length }}
          />
        ) : (
          <FormattedMessage id="Missions.Applicants.MissionRoleFilter.EditButtonText" />
        )}
      </EditButton>
      {showForm && (
        <MissionRolesPicker
          show={showForm}
          onClose={() => setShowForm(false)}
          title={<FormattedMessage id="Missions.Applicants.MissionRoleFilter.MissionRolePicker.Title" />}
          info={<FormattedMessage id="Missions.Applicants.MissionRoleFilter.MissionRolePicker.Description" />}
          onSelect={setMissionRoleIds}
          onSubmit={() => {
            setShowForm(false);
            setSelected({ ...selected, missionRoleIds });
          }}
          filters={{ organizationId: selected?.organizationId, published: showOnlyPublishedRoles }}
          missionId={selected?.missionId}
          selectionInitialState={selected?.missionRoleIds}
          disablePagination
          showSave
          selectable
          canSubmit
        />
      )}
    </>
  );
};

ApplicantListMissionRoleFilter.propTypes = {
  selected: PropTypes.object,
  setSelected: PropTypes.func,
  showOnlyPublishedRoles: PropTypes.bool,
};

export default ApplicantListMissionRoleFilter;
